'use strict';

const linkSelector = '.nav-mobile__link';
const itemSelector = '.nav-mobile__item';
const backSelector = '.nav-mobile__item--back';
const itemActiveClass = 'nav-mobile__item--active';
const parentActiveClass = 'is-active';
const menuActiveClass = 'nav-open-inverted';
const menuBtnId = 'nav-btn';

(function () {
    const links = document.querySelectorAll(linkSelector);
    const backLinks = document.querySelectorAll(backSelector);
    const menuBtn = document.getElementById(menuBtnId);

    if (!links.length) {
        return;
    }

    links.forEach(link => {
        const process = () => {
            link.closest('ul').querySelectorAll(itemSelector).removeClass(itemActiveClass);
            link.closest('li').classList.add(itemActiveClass);

            document.body.classList.add(menuActiveClass);

            if (link.nextElementSibling) {
                link.closest('ul').classList.add(parentActiveClass);
                link.nextElementSibling.nextElementSibling.classList.remove(parentActiveClass);
            } else {
                link.closest('ul').classList.remove(parentActiveClass);
            }
        }

        if (link.nextElementSibling) {
            link.nextElementSibling.addEventListener('click', process);
        }
    });

    backLinks.forEach(backLink => {
        const backProcess = () => {
            backLink.closest('.nav-mobile__item.has-child').classList.remove(itemActiveClass);
            backLink.closest('.nav-mobile__item.has-child').closest('ul').classList.remove(parentActiveClass);

            if(backLink.parentElement.classList.contains('nav-mobile--level-1')) {
                document.body.classList.remove(menuActiveClass);
            }
        }

        backLink.addEventListener('click', backProcess);
    });

    if(menuBtn) {
        const resetMenu = () => {
            links.forEach(link => {
                link.closest('ul').querySelectorAll(itemSelector).removeClass(itemActiveClass);
                link.closest('ul').classList.remove(parentActiveClass);
                document.body.classList.remove(menuActiveClass);
            });
        }

        menuBtn.addEventListener('click', resetMenu);
    }
}());
